import { render, staticRenderFns } from "./paivittainen-merkinta-form.vue?vue&type=template&id=bc3ffad6&"
import script from "./paivittainen-merkinta-form.vue?vue&type=script&lang=ts&"
export * from "./paivittainen-merkinta-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports